(function () {
    'use strict';

    angular
        .module('app')
        .controller('LandingPageController', LandingPageController);

    LandingPageController.$inject = ['$scope', '$http', '$stateParams', '$rootScope', 'cache', '$state', 'localization', '$cookies', 'eventTracker'];

    function LandingPageController($scope, $http, $stateParams, $rootScope, cache, $state, localization, $cookies, eventTracker) {
        $rootScope.header_inverted = true;
        $rootScope.on_dashboard = false;
        $rootScope.separate_page = false;
        $rootScope.dark_text_header = false;
        var vm = this;

        vm.danish_cities = [
            'copenhagen',
            'odense',
            'aarhus',
            'randers',
            'esbjerg',
            'aalborg'
        ];
        vm.swedish_cities = [
            'stockholm',
            'goteborg',
            'malmo',
            'uppsala',
            'helsingborg'
        ];

        function mapCity (city) {
            switch(city) {
                case 'copenhagen':
                case 'københavn':
                    vm.danish_city = true;
                    vm.title = 'Live musik i København | Oplev livekoncert i København';
                    vm.description = 'Oplev live musik i din egen stue eller tag med til koncert i København. Be My Concert giver dig en unik musikoplevelse i København.';
                    return 'copenhagen';
                case 'odense':
                    vm.danish_city = true;
                    vm.title = 'Live musik nær Odense | Oplev koncerter i Odense';
                    vm.description = 'Oplev livekoncerter i Odense. Se hvor der er live musik i Odense i dag. Be My Concert giver dig en unik musikoplevelse i Odense.';
                    return 'odense';
                case 'århus':
                case 'aarhus':
                    vm.danish_city = true;
                    vm.title = 'Live musik nær Århus | Oplev live musik i Århus i dag';
                    vm.description = 'Leder du efter live musik i Århus i dag? Se mere på Be My Concert\'s hjemmeside for at opleve live musik i Århus. ';
                    return 'aarhus';
                case 'ålborg':
                case 'aalborg':
                    vm.danish_city = true;
                    vm.title = 'Live musik nær Aalborg | Oplev musik i Aalborg i dag';
                    vm.description = 'Er du på udkig efter live musik i dag i Aalborg? Besøg Be My Concert hjemmeside, hvis du vil høre live musik i Aalborg.';
                    return 'aalborg';
                case 'randers':
                    vm.danish_city = true;
                    vm.title = 'Live musik nær Randers | Oplev musik i randers';
                    vm.description = 'Se vores koncerter i Randers. Besøg Be My Concert hjemmeside, hvis du vil opleve live musik i randers.';
                    return 'randers';
                case 'esbjerg':
                    vm.danish_city = true;
                    vm.title = 'Koncerter i Esbjerg | Oplev like musik i esbjerg';
                    vm.description = 'Få et overblik over koncerter og live musik i Esbjerg på Be My Concert\'s hjemmeside. Se hvad der sker i Esbjerg i dag.';
                    return 'esbjerg';
                case 'stockholm':
                    vm.swedish_city = true;
                    vm.title = 'Upplev livemusik i Stockholm | Levande musik stockholm';
                    vm.description = 'Upplev levande musik i ditt eget vardagsrum eller gå på konsert i Stockholm. Be My Concert ger dig en unik musikupplevelse i Stockholm.';
                    return 'stockholm';
                case 'goteborg':
                case 'göteborg':
                    vm.swedish_city = true;
                    vm.title = 'Upplev livemusik i göteborg | levande musik göteborg';
                    vm.description = 'Se våra konserter i Göteborg. Besök Be My Concert:s webbplats om du vill uppleva livemusik i Göteborg.';
                    return 'goteborg';
                case 'malmo':
                case 'malmö':
                    vm.swedish_city = true;
                    vm.title = 'Upptäck livemusik i Malmö | musik i malmö';
                    vm.description = 'Se var det finns livemusik i Malmö idag och få en unik musikupplevelse med Be My Concert i Malmö. Upplev livekonserter i Malmö. ';
                    return 'malmo';
                case 'uppsala':
                    vm.swedish_city = true;
                    vm.title = 'intim livemusik i uppsala | musik i uppsala';
                    vm.description = 'Få en intim musikupplevelse i uppsala. Besök Be My Concert webbplats och se om det finns livemusik i uppsala idag.';
                    return 'uppsala';
                case 'helsingborg':
                    vm.swedish_city = true;
                    vm.title = 'Hitta livemusik i Helsingborg | musik i helsingborg';
                    vm.description = 'Få en upplevelse av livemusik i helsingborgs. hitta livemusik i helsingborgs på Be My Concert-webbplats';
                    return 'helsingborg';
                case 'intimkoncert':
                    vm.danish_city = true;
                    vm.title = ' Intimkoncerter med god stemning hos Be My Concert i Danmark - Kom og oplev live musik tæt på';
                    vm.description = 'Oplev live musik i din egen stue eller tag med til koncert. Be My Concert giver dig en unik musikoplevelse.';
                    vm.no_2nd_row_text = true;
                    vm.no_3rd_row_text = true;
                    return 'intimkoncert';
                default:
                    return $state.go('item_deleted');
            }
        }

        vm.$onInit =  function () {
            vm.city = mapCity($stateParams.city);
            vm.cities = vm.danish_city ? vm.danish_cities : vm.swedish_cities;
            window.document.title = vm.title;
            document.getElementsByTagName('meta')["title"].content = vm.title;
            document.getElementsByTagName('meta')["description"].content = vm.description;
            getConcerts();
        }

        vm.goToBrowsePage = function() {
            switch(vm.city) {
                case 'copenhagen':
                    return $state.go('concerts', {location: encodeURI('København')});
                case 'odense':
                    return $state.go('concerts', {location: encodeURI('Fyn og øerne')});
                case 'aarhus':
                    return $state.go('concerts', {location: encodeURI('Østjylland')});
                case 'randers':
                    return $state.go('concerts', {location: encodeURI('Østjylland')});
                case 'esbjerg':
                    return $state.go('concerts', {location: encodeURI('Sydjylland')});
                case 'aalborg':
                    return $state.go('concerts', {location: encodeURI('Nordjylland')});
                case 'stockholm':
                    return $state.go('concerts');
                case 'goteborg':
                    return $state.go('concerts');
                case 'malmo':
                    return $state.go('concerts');
                case 'uppsala':
                    return $state.go('concerts');
                case 'helsingborg':
                    return $state.go('concerts');
                case 'intimkoncert':
                    return $state.go('concerts');
                default:
                    return $state.go('concerts');
            }
        }

        function getConcerts() {
            var data = {
                'genre': [],
                'tag': [],
                'freetext': "",
                'country' : "DK",
                'adminFilter': [],
                'limit': 12,
                'offset': 0,
                'sortby': "concert_date",
                'dateRangeStart': null,
                'dateRangeEnd': null
            }
            switch(vm.city) {
                case 'copenhagen':
                    data.location = [{"country_region_id":1,"country_region_name":"København","country_iso_code":"DK","number_of":"3","selected":true}];
                    break;
                case 'odense':
                    data.location = [{"country_region_id":7,"country_region_name":"Fyn og øerne","country_iso_code":"DK","number_of":"8","selected":true}];
                    break;
                case 'aarhus':
                    data.location = [{"country_region_id":10,"country_region_name":"Østjylland","country_iso_code":"DK","number_of":"15","selected":true}];
                    break;
                case 'randers':
                    data.location = [{"country_region_id":10,"country_region_name":"Østjylland","country_iso_code":"DK","number_of":"15","selected":true}];
                    break;
                case 'esbjerg':
                    data.location = [{"country_region_id":8,"country_region_name":"Sydjylland","country_iso_code":"DK","number_of":"15","selected":true}];
                    break;
                case 'aalborg':
                    data.location = [{"country_region_id":11,"country_region_name":"Nordjylland","country_iso_code":"DK","number_of":"5","selected":true}];
                    break;
                case 'stockholm':
                    data.country = "SE";
                    break;
                case 'goteborg':
                    data.country = "SE";
                    break;
                case 'malmo':
                    data.country = "SE";
                    break;
                case 'uppsala':
                    data.country = "SE";
                    break;
                case 'helsingborg':
                    data.country = "SE";
                    break;
                case 'intimkoncert':
                    break;
                default:
                    data.location = [{"country_region_id":1,"country_region_name":"København","country_iso_code":"DK","number_of":"3","selected":true}];
                    break;
            }

            return $http.post('api/list/concerts/', data)
                .then(function (response) {
                    vm.concerts = response.data.data;
                    vm.concertsJsonId = [];
                    Object.values(vm.concerts).forEach(function(element) {
                        vm.concertsJsonId.push({
                        "@context": "https://schema.org",
                        "@type": "Event",
                        "name": element.concert_name,
                        "image": "https://bemyconcert.com/uploads/bands/" + element.band_slug + "/" + element.band_image_hash + "_xl.jpeg",
                        "startDate": moment(element.concert_start_time).toISOString(),
                        "endDate": moment(element.concert_end_time).toISOString(),
                        "eventStatus": "https://schema.org/EventScheduled",
                        "eventAttendanceMode": "https://schema.org/OfflineEventAttendanceMode",
                        "url": "https://bemyconcert.com/concert/" + element.concert_slug,
                        "location": {
                            "@type": "Place",
                            "name": element.space_name,
                            "address": {
                            "@type": "PostalAddress",
                            "streetAddress": "",
                            "addressLocality": element.concert_city,
                            "postalCode": element.concert_zip,
                            "addressCountry": element.concert_country
                            }
                        },
                        "performer": {
                            "@type": "MusicGroup",
                            "name": element.band_name
                        }
                        });
                    });
                });
        }

    }
})();
